import React, { useState } from "react";
import Select from "react-select";
import Helpers from "../../../helper/helper";
import LightbarDrawing from "./LightbarDrawing";
import { CUSTOM_OPTION, LIGHTBAR_LIGHTHEAD_MODAL_TITLE } from "../../../services/Constant";

const LightBarPreviewComponent = ({
  lightData,
  closeLightbarPreviewModel,
  tooltipData,
  currentZoneData,
  setLightbarLightheadsCallingBlocking,
  isOntario,
}) => {
  const ModalSoloTitle = "Preview";
  const [callingBlockingValues, setCallingBlockingValues] = useState([]);
  const [selectedIntensityValues, setSelectedIntensityValues] = useState([]);
  const FindSelectedIndex = (options, value) => options.findIndex((x) => x.value === value);
  const colorMap = [...(currentZoneData?.lightheads || [])]
    .sort((a, b) => {
      if (a.lightheadPosition == null) return 0;
      if (b.lightheadPosition == null) return 0;

      return a.lightheadPosition - b.lightheadPosition;
    })
    .reduce(
      (acc, lighthead, i) => ({
        ...acc,
        [i]: Object.keys(lighthead.color).map((key) => ({
          ...lighthead,
          ...lighthead.color[key],
        })),
      }),
      {}
    );
  const solo = currentZoneData?.lightheads.length === 0;

  const setCallingBlockingSelection = (e, mainIndex, colorIndex, id, intensity) => {
    setCallingBlockingValues((prev) => {
      const checkIfExist = prev.some(
        (lighthead) =>
          lighthead.id === id &&
          lighthead.e === e &&
          lighthead.mainIndex === mainIndex &&
          lighthead.intensity === intensity &&
          lighthead.colorIndex === colorIndex
      );
      if (checkIfExist) {
        return prev;
      }
      const filteredValues = prev.filter(
        (lighthead) =>
          !(
            lighthead.id === id &&
            lighthead.intensity === intensity &&
            lighthead.mainIndex === mainIndex &&
            lighthead.colorIndex === colorIndex
          )
      );
      return [...filteredValues, { e, mainIndex, colorIndex, id, intensity }];
    });
  };
  return (
    <>
      <div id="previewLightbar-modal" className="m-auto">
        <div className="modal-dialog m-0">
          <div className="modal-content">
            <div className="d-flex align-items-center">
              <h3 className="modal-title text-white mt-0">{solo ? ModalSoloTitle : LIGHTBAR_LIGHTHEAD_MODAL_TITLE}</h3>
              <div className="close-icon text-end ms-auto">
                <button type="button" className="close" data-dismiss="modal" onClick={closeLightbarPreviewModel}>
                  <span aria-hidden="true">
                    <i className="fa fa-times text-red" />
                  </span>
                </button>
              </div>
            </div>
            <LightbarDrawing lightData={lightData} currentZoneData={currentZoneData} tooltipData={tooltipData} />
            {!solo ? (
              <>
                <div className="table-responsive" style={{ height: "calc(100vh - 440px)" }}>
                  <table className="table el-header table-bordered align-middle table-dark table-sm-cell">
                    <thead>
                      <tr>
                        {currentZoneData && currentZoneData?.bxrVersion === "2.0" ? <th>Lighthead Position</th> : null}
                        <th>Source</th>
                        <th>Position</th>
                        <th>Calling Intensity</th>
                        <th>Blocking Intensity</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Object.keys(colorMap).map((colorRow, mainIndex) =>
                        colorMap[colorRow].map((row, colorIndex) => (
                          <tr key={`${colorRow}-${row.id + colorIndex}`}>
                            {currentZoneData && currentZoneData?.bxrVersion === "2.0" ? (
                              <td>{colorIndex <= 0 && row?.lightheadPosition ? row.lightheadPosition : null}</td>
                            ) : null}
                            <td>{`${row?.modelNumber} - ${row?.color}`}</td>
                            <td>{row.position}</td>
                            <td style={{ minWidth: "180px" }}>
                              <div className="form-group cursor-pt mb-0">
                                <Select
                                  value={
                                    selectedIntensityValues[`${row.id + colorIndex}c`] ??
                                    currentZoneData?.intensityOptions[
                                      FindSelectedIndex(currentZoneData?.intensityOptions, row.call_intensity)
                                    ]
                                  }
                                  options={currentZoneData?.intensityOptions.filter(
                                    (option) => option.value !== CUSTOM_OPTION
                                  )}
                                  className="select-sdd"
                                  isSearchable={false}
                                  // menuPortalTarget={document.body}
                                  menuPosition="fixed"
                                  // styles={Helpers.getDropDownOptionsForPreviewModel()}
                                  styles={Helpers.getDropDownStyleZoneRtnAbs()}
                                  onChange={(e) => {
                                    setSelectedIntensityValues((prev) => ({
                                      ...prev,
                                      [`${row.id + colorIndex}c`]: e,
                                    }));
                                    setCallingBlockingSelection(e, mainIndex, colorIndex, row.id, "call_intensity");
                                  }}
                                />
                              </div>
                            </td>
                            <td style={{ minWidth: "180px" }}>
                              <div className={`form-group ${isOntario} ? cursor-na : cursor-pt mb-0`}>
                                <Select
                                  value={
                                    selectedIntensityValues[`${row.id + colorIndex}b`] ??
                                    currentZoneData?.intensityOptions[
                                      FindSelectedIndex(currentZoneData?.intensityOptions, row.block_intensity)
                                    ]
                                  }
                                  options={currentZoneData?.intensityOptions.filter(
                                    (option) => option.value !== "Custom"
                                  )}
                                  className="select-sdd"
                                  isSearchable={false}
                                  // menuPortalTarget={document.body}
                                  menuPosition="fixed"
                                  // styles={Helpers.getDropDownOptionsForPreviewModel()}
                                  styles={Helpers.getDropDownStyleZoneRtnAbs(isOntario)}
                                  onChange={(e) => {
                                    setSelectedIntensityValues((prev) => ({
                                      ...prev,
                                      [`${row.id + colorIndex}b`]: e,
                                    }));
                                    setCallingBlockingSelection(e, mainIndex, colorIndex, row.id, "block_intensity");
                                  }}
                                  isDisabled={isOntario}
                                />
                              </div>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
                <div className="action-btn">
                  <button
                    type="button"
                    className="btn btn-red text-white text-uppercase"
                    onClick={closeLightbarPreviewModel}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-red text-white text-uppercase apply"
                    onClick={() => {
                      setLightbarLightheadsCallingBlocking(callingBlockingValues, currentZoneData);
                      setTimeout(() => {
                        closeLightbarPreviewModel();
                      }, 1);
                    }}
                  >
                    Apply
                  </button>
                </div>
              </>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
};

export default LightBarPreviewComponent;
